export const RESET = 'EXSBITEMSCATEGORY_UPDATE_RESET'
export const SET_ERROR = 'EXSBITEMSCATEGORY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBITEMSCATEGORY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBITEMSCATEGORY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBITEMSCATEGORY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBITEMSCATEGORY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBITEMSCATEGORY_UPDATE_UPDATE_RETRIEVED'
